<template>
  <div class="random-episode">
    <a href="javascript:;" v-on:click="getRandomEpisode">
      <h3>{{ msg }}</h3>
    </a>
    <episode :episode="episode"/>
  </div>
</template>

<script>
import Episode from '@/components/Episode';
import getRandomEpisode from '../lib/getRandomEpisode';

export default {
  components: { Episode },
  name: 'random-episode',
  props: ['within', 'seasonNumber', 'episodeNumber'],
  watch: {
    // Required for back/forward to work
    episodeNumber() {
      if (
        !this.episode ||
        +this.episodeNumber !== this.episode.airedEpisodeNumber ||
        +this.seasonNumber !== this.episode.airedSeason
      ) {
        this.episode = this.$store.getters.episode(this.seasonNumber, this.episodeNumber);
      }
    }
  },
  data() {
    let msg = '';
    switch (this.within) {
      case 'season':
        msg = 'Get another random episode from Season ' + this.seasonNumber + '!';
        break;
      case 'all':
        msg = 'Get another random episode from any season!';
        break;
    }

    return {
      msg,
      episode: this.$store.getters.episode(this.seasonNumber, this.episodeNumber)
    };
  },
  methods: {
    getRandomEpisode
  }
};
</script>



// WEBPACK FOOTER //
// RandomEpisode.vue?1fc07cd6